import { styled } from '@mui/material';

const PREFIX = 'FundFilter';

export const classes = {
  root: `${PREFIX}-root`,
  input: `${PREFIX}-input`,
  icon: `${PREFIX}-icon`,
  focused: `${PREFIX}-focused`,
  notchedOutline: `${PREFIX}-notchedOutline`,
  autocompleteOption: `${PREFIX}-autocompleteOption`,
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    opacity: 0,
    width: '100%',

    '&.open': {
      opacity: 1,
    },
  },

  [`& .${classes.input}`]: {
    color: '#fff',
    padding: '4px 10px 4px !important',
  },

  [`& .${classes.icon}`]: {
    color: 'rgba(255, 255, 255, 0.5)',
  },

  [`& .${classes.focused}`]: {
    backgroundColor: '#fff',
    color: '#293033',
    '& $icon': {
      color: theme.palette.primary.main,
    },
  },

  [`& .${classes.notchedOutline}`]: {
    borderColor: 'rgba(255, 255, 255, 0.5) !important',
  },

  [`& .${classes.autocompleteOption}`]: {
    padding: 0,
  },
}));
